import { useEffect } from 'react';
import { showTelegramAlert } from '../utils/telegramActions';
import { useUIText, useAppConstants } from './useConfig';

export const useNetworkStatus = () => {
    const UI_TEXT = useUIText();
    const APP_CONFIG = useAppConstants();

    useEffect(() => {
        const checkConnection = async () => {
            try {
                // Пытаемся сделать запрос к надежному серверу
                // Добавляем timestamp, чтобы избежать кэширования
                const pingUrl = APP_CONFIG.API?.PING_URL || 'https://jsonplaceholder.typicode.com/todos/1';
                await fetch(`${pingUrl}?_=${Date.now()}`, { method: 'HEAD' });
                return true;
            } catch (error) {
                return false;
            }
        };

        const handleOffline = () => {
            const errorMessage = UI_TEXT.ERRORS?.OFFLINE || 'Отсутствует подключение к интернету. Проверьте настройки сети и нажмите ОК для повторной проверки.';
            showTelegramAlert(
                errorMessage,
                async () => {
                    // Колбэк вызывается после закрытия алерта
                    const isOnline = await checkConnection();
                    if (!isOnline) {
                        // Если все еще нет интернета, показываем алерт снова
                        handleOffline();
                    }
                }
            );
        };

        window.addEventListener('offline', handleOffline);

        // Также можно проверять при загрузке
        if (!navigator.onLine) {
            handleOffline();
        }

        return () => {
            window.removeEventListener('offline', handleOffline);
        };
    }, [UI_TEXT, APP_CONFIG]);
};
